import { flexRender } from '@tanstack/react-table';
import { useDragNDrop } from '@/hooks/useDragNDrop';
import type { TdmType } from '@/types/Tdm';

const TableRow = ({
  tdmType,
  row,
  index,
  moveRow,
  onRowClick,
}: {
  tdmType: TdmType;
  row: any;
  index: number;
  moveRow: (dragIndex: number, hoverIndex: number) => void;
  onRowClick?: (row: any) => void;
}) => {
  const { trRef, handlerId, opacity } = useDragNDrop({
    tdmType: tdmType,
    id: row.original.sortIndex,
    index,
    moveRow: moveRow,
  });
  return (
    <tr
      ref={trRef}
      className={`${opacity} hover:bg-green-50 cursor-pointer`}
      onClick={() => onRowClick?.(row.original)}
      data-handler-id={handlerId}
    >
      {row.getVisibleCells().map((cell: any) => (
        <td
          key={cell.id}
          style={{
            minWidth: cell.column.columnDef.minSize,
            maxWidth: cell.column.columnDef.maxSize,
            width: cell.column.columnDef.size,
          }}
          className='px-6 py-4'
        >
          {flexRender(cell.column.columnDef.cell, cell.getContext())}
        </td>
      ))}
    </tr>
  );
};

export default TableRow;
